var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('IdfStep',{attrs:{"title":_vm.$t('ctx.discount.detail.article-associations').toString(),"disabled":false}},[(!_vm.discount.isMeta)?_c('CReadonlyDiscountAssociations',{attrs:{"discount":_vm.discount}}):_c('CReadonlyMetaDiscountAssociations',{attrs:{"discount":_vm.discount}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }